import pluralize from "pluralize";
import { PlayerCardWidgetOwner } from "../../services/bedrock";
import _ from "lodash";
import {
  AlignVerticalJustifyEnd,
  AlignVerticalJustifyStart,
  BrainCircuit,
  ContactRound,
  FilePlay,
  Link,
  Mail,
  MapPinHouse,
  Newspaper,
  Phone,
  Share2,
  SignpostBig,
} from "lucide-react";

export const getCountMetricsText = (num: number, metricType?: string) => {
  var countText = num.toString();
  if (num >= 1000000) {
    countText = (num / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
  } else if (num >= 1000) {
    countText = (num / 1000).toFixed(1).replace(/\.0$/, "") + "k";
  }
  if (metricType) {
    return `${countText} ${pluralize(metricType, num)}`;
  } else {
    return countText;
  }
};

export const getWidgetTitle = (widgetType: string) => {
  return (
    {
      ContentPage: "Video Page",
      SocialMedia: "Social Media",
      SmartLink: "Smart Link",
    }[widgetType] || widgetType
  );
};

export const getWidgetSubtitle = (widgetOwner: PlayerCardWidgetOwner) => {
  if (widgetOwner.type === "Link") {
    return widgetOwner.url;
  } else if (widgetOwner.type === "ContentPage" || widgetOwner.type === "Blog") {
    return _.startCase(_.capitalize(widgetOwner.selectionType));
  } else if (widgetOwner.type === "Phone") {
    return widgetOwner.phoneNumber;
  } else if (widgetOwner.type === "Email") {
    return widgetOwner.email;
  } else if (widgetOwner.type === "Address") {
    return [
      [widgetOwner.streetLine1, widgetOwner.streetLine2].filter(Boolean).join(" "),
      widgetOwner.city,
      [widgetOwner.state, widgetOwner.zip].filter(Boolean).join(" "),
    ]
      .filter(Boolean)
      .join(", ");
  } else {
    return null;
  }
};

export const getWidgetIcon = (widgetOwner: PlayerCardWidgetOwner): React.ElementType => {
  const iconMapping: Record<PlayerCardWidgetOwner["type"], React.ElementType> = {
    Link: Link,
    SocialMedia: Share2,
    ContentPage: FilePlay,
    Blog: Newspaper,
    Post: SignpostBig,
    SmartLink: BrainCircuit,
    Phone: Phone,
    Email: Mail,
    Address: MapPinHouse,
    Contact: ContactRound,
    Header: AlignVerticalJustifyStart,
    Footer: AlignVerticalJustifyEnd,
  };
  return iconMapping[widgetOwner.type];
};
